import styled from 'styled-components';

export default styled.div`
	#change-month-handler {
		width: 50px;
		height: 50px;
		position: fixed;
		bottom: 100px;
		left: 20px;
		border-radius: 10rem;
		background: #000;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 0;
		z-index: 19;
		svg {
			fill: #fff;
		}
	}
	#month-list-wrapper {
		position: fixed;
		bottom: 0;
		z-index: 20;
		right: 0;
		left: 0;
		background: #000;
		border-top-right-radius: 20px;
		border-top-left-radius: 20px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 30px 20px;
		#month-list {
			.month-item {
				display: inline-flex;
				width: calc(100% / 3 - 20px);
				margin: 10px;
				.month-button {
					width: 100%;
					border: 0;
					padding: 10px;
					border-radius: 5px;
					background: #151515;
					color: #fff;
					transition: all 200ms ease;
				}
				&.active .month-button {
					background: #f54949;
				}
			}
		}
	}
	#modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 19;
	}
`;
